<template>
  <nav-bar title="修改用户基本信息" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <van-form @submit="handleSubmit">
      <Picker
        label="客户类型"
        :require="true"
        :columns="columns"
        :defaultVal="oldForm.userTypeName"
        @confirm-values="value => (oldForm.userType = value.dicVal)"
      />
      <Field name="companyName" :defaultValue="oldForm.companyName" label="客户名" :require="true" />
      <Field  name="creditNo" :defaultValue="oldForm.creditNo" label="客户代码"  :require="true"/>
      <Field name="userName" :defaultValue="oldForm.userName" label="联系人" :require="true" />
      <Field name="phoneNum" :defaultValue="oldForm.phoneNum" label="联系电话" :require="true" />
      <Picker
        label="街道"
        pickerType="cascader"
        :defaultVal="oldForm.streetName"
        @confirm-values="value => (oldForm.streetCode = value)"
      />

      <Field name="address" :defaultValue="oldForm.address" label="地址" :require="true" />
      <!-- <Field
        label="位置"
        :defaultValue="`${oldForm.latitude}, ${oldForm.longitude}`"
      /> -->
      <van-field label="是否反馈">
        <template #input>
          <van-radio-group v-model="oldForm.backFlag " direction="horizontal">
            <van-radio name="0">是</van-radio>
            <van-radio name="1">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <SelectPoint @get-value="selectPoint" :defaultValue="`${oldForm.latitude}, ${oldForm.longitude}`"  />
      <div class="btn-container">
        <van-button
          block
          type="primary"
          :loading="loading"
          loading-text="请稍后..."
          :disabled="loading"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>

  </Content>
</template>

<script>
import { getCustomerDetail, getMessListById, updateMessById } from '@/api/customer'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useGetData } from '@/hooks/useGetData'
import { ref, reactive, computed } from 'vue'
import SelectPoint from '../NewCustomers/SelectPoint.vue'
import { useRouter } from 'vue-router'
import { Notify } from 'vant'
import { useStore } from 'vuex'
export default {
  name: 'ModifySalesCust',
  components: { SelectPoint },
  props: ['id'],
  setup (props) {
    const store = useStore()
    const roleId = computed(() => store.state.roleInfo.roleId)
    const updateUserId = computed(() => store.state.userInfo.id)
    const oldForm = reactive({
      roleId: roleId.value,
      updateUserid: updateUserId.value
    })
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getCustomerDetail, (data) => {
      for (const key in data) {
        oldForm[key] = data[key]
      }
    }, props.id)
    getDataLoading()
    // LIST
    const columns = ref([])
    useGetData(getMessListById, data => {
      columns.value = data
    })()
    // 选择位置
    const selectPoint = value => {
      oldForm.latitude = value[0]
      oldForm.longitude = value[1]
    }
    const router = useRouter()
    const loading = ref(false)
    const handleSubmit = (values) => {
      const params = { ...oldForm, ...values }
      loading.value = true
      updateMessById(params).then(() => {
        router.back()
        loading.value = false
        Notify({ type: 'success', message: '操作成功' })
      }).catch(() => {
        loading.value = false
      })
      // onSubmit(formData)
    }
    return { getDataLoading, showLoading, isLoading, handleSubmit, columns, oldForm, selectPoint, loading }
  }
}
</script>

<style lang="scss" scoped>
.btn-container {
  margin: 16px;
}
</style>
